import axios from 'axios';
import qs from 'qs';
import Vue from 'vue'
// axios.defaults.baseURL = 'http://192.168.0.30:28306'
// axios.defaults.baseURL = 'https://papi.tubiaojia.com'
// axios.defaults.baseURL = 'https://apinewtest.tubiaojia.com'

// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.timeout = 5000;


// axios.interceptors.request.use((config) => {
//     // Vue.$vux.loading.show({
//     //     text: 'Loading'
//     // })
//     if(config.method  === 'post'){
//         if(config.headers['Content-Type'] === 'multipart/form-data'){
//             config.data = qs.stringify(config.data);
//         }
//     }
//     return config;
// },(error) =>{
//     return Promise.reject(error);
// });
//




export function get(url:string,params={}){
    return new Promise((resolve,reject) => {
        axios.get(url,{
            params:params
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function post(url:string,data={}){
    return new Promise((resolve,reject) => {
        axios.post(url,qs.stringify(data))
            .then(response => {
                resolve(response.data);
            },err => {
                reject(err)
            })
    })
}

export function postConfig(url:string,data:any,config:any){
    return new Promise((resolve,reject) => {
        axios.post(url,data,config)
            .then(response => {
                resolve(response.data);
            },err => {
                reject(err)
            })
    })
}
